import { useUsersLastChangesPage } from 'src/hooks/usersLastChange';
import { tryCall } from 'src/utils/core/functions';
import { usePageChanged } from 'src/hooks/utils';
import { getSorting } from 'src/utils/data/sorting';
import { useUsers } from 'src/hooks/user';

export default () => {
  const {
    data,
    refetch,
    loading,
    fetchMore,
    variables,
  } = tryCall(() => useUsersLastChangesPage({
    limit: 15,
    offset: 0,
    ...getSorting('UsersManagerDashboardGrid', {
      orderBy: 'created_at',
      orderDirection: 'desc',
    }),
  }), { data: [], loading: false, refetch: () => {}, fetchMore: () => {}, variables: {} });

  const onPageChanged = usePageChanged(fetchMore, '');

  const { data: usersData } = tryCall(() => useUsers({
    limit: 1000,
    offset: 0,
  }), { data: [] });
  const users = (usersData && usersData.users) || [];

  return [
    {
      data:
        (data && {
          items: data.usersLastChanges,
          pageInfo: data.usersLastChangesPageInfo,
        }) ||
        {},
      loading,
      refetch,
      variables,
      users,
    },
    { onPageChanged },
  ];
};
